module.exports = __webpack_public_path__ + "img/circle-check.c410981a.svg";